import React from 'react';
import { Typography } from 'src/components';
import { CRMObject } from './types';
import CRMLinkItem from './CRMLinkItem';
import MultipleLinksMessage from './MultipleLinksMessage';

interface CRMMultipleLinksProps {
  links: CRMObject[];
  isExpanded: boolean;
  toggleExpanded: () => void;
  onDelete?: (crmLink: CRMObject) => void;
}

const CRMMultipleLinks: React.FC<CRMMultipleLinksProps> = ({
  links,
  isExpanded,
  toggleExpanded,
  onDelete,
}) => {
  const displayLinks = isExpanded ? links : links.slice(0, 5);
  const hasMoreLinks = links.length > 5;

  return (
    <>
      {displayLinks.map((crmObject, idx) => (
        <CRMLinkItem key={idx} crmObject={crmObject} onDelete={onDelete} />
      ))}

      {hasMoreLinks && (
        <div className="cursor-pointer" onClick={toggleExpanded}>
          <Typography className="text-tertiary hover:text-primary text-sm font-semibold">
            {isExpanded ? 'View less' : `View ${links.length - 5} more`}
          </Typography>
        </div>
      )}

      <MultipleLinksMessage />
    </>
  );
};

export default CRMMultipleLinks;
